const data = {
  security: {
    permission: { url: process.env.REACT_APP_URL_PERMISSIONS_ALLOW },
    login: { url: process.env.REACT_APP_URL_LOGIN },
    assingnRole: { url: process.env.REACT_APP_URL_ASSIGN_ROLE },
  },

  providers: {
    provider: { url: process.env.REACT_APP_URL_PROVIDERS },
    type: { url: process.env.REACT_APP_URL_TYPES },
    conceptMaster: { url: process.env.REACT_APP_URL_TYPE_CONCEPT },
    userArea: { url: process.env.REACT_APP_URL_AREAS },
    monitor: { url: process.env.REACT_APP_URL_MONITOR },
    users: { url: process.env.REACT_APP_URL_USERS },
    supplier: { url: process.env.REACT_APP_SUPPLIER },
    society: { url: process.env.REACT_APP_URL_SOCIETYS },
    email: { url: process.env.REACT_APP_URL_EMAIL },
    bank: { url: process.env.REACT_APP_URL_BANK },
    paymentDetail: { url: process.env.REACT_APP_URL_PAYMENT },
    fileRequirement: { url: process.env.REACT_APP_URL_FILE_REQUIREMENT },
    fileUpload: { url: process.env.REACT_APP_URL_FILE_UPLOAD },
    notificationEmail: { url: process.env.REACT_APP_URL_NOTIFICATIONS_EMAIL },
    materialSupplier: { url: process.env.REACT_APP_URL_MATERIAL_SUPPLIER },
  },
}

export default {
  data,
}
